"use strict";
var $a5fd07fa01589658$exports = {};
"use strict";
class $a5fd07fa01589658$var$Game {
    constructor(initialState = [
        [
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0
        ]
    ]){
        this.initialState = initialState.map((row)=>[
                ...row
            ]);
        this.grid = initialState.map((row)=>[
                ...row
            ]);
        this.score = 0;
        this.status = "idle";
    }
    moveLeft() {
        if (this.status !== "playing") return;
        const prevState = JSON.stringify(this.grid);
        this.grid = this.grid.map((row)=>this._slideAndMerge(row));
        this._postMoveHandler(prevState);
    }
    moveRight() {
        if (this.status !== "playing") return;
        const prevState = JSON.stringify(this.grid);
        this.grid = this.grid.map((row)=>this._slideRight(row));
        this.grid = this.grid.map((row)=>this._mergeRight(row));
        this._postMoveHandler(prevState);
    }
    _slideRight(row) {
        const filtered = row.filter((cell)=>cell !== 0);
        const merged = new Array(4).fill(0);
        let emptyIndex = 3;
        for(let i = filtered.length - 1; i >= 0; i--)merged[emptyIndex--] = filtered[i];
        return merged;
    }
    _mergeRight(row) {
        const merged = row.slice();
        for(let i = 3; i > 0; i--)if (merged[i] === merged[i - 1] && merged[i] !== 0) {
            merged[i] *= 2;
            this.score += merged[i];
            merged[i - 1] = 0;
        }
        return this._slideRight(merged);
    }
    moveUp() {
        if (this.status !== "playing") return;
        const prevState = JSON.stringify(this.grid);
        this._transposeGrid();
        this.grid = this.grid.map((row)=>this._slideAndMerge(row));
        this._transposeGrid();
        this._postMoveHandler(prevState);
    }
    moveDown() {
        if (this.status !== "playing") return;
        const prevState = JSON.stringify(this.grid);
        this._transposeGrid();
        this.grid = this.grid.map((row)=>this._slideAndMerge(row.reverse()).reverse());
        this._transposeGrid();
        this._postMoveHandler(prevState);
    }
    getScore() {
        return this.score;
    }
    getState() {
        return this.grid;
    }
    getStatus() {
        return this.status;
    }
    start() {
        if (this.status !== "idle") return;
        this.status = "playing";
        this._addRandomCell();
        this._addRandomCell();
    }
    restart() {
        this.score = 0;
        this.grid = this.initialState.map((row)=>[
                ...row
            ]);
        this.status = "idle";
    }
    _slideAndMerge(row) {
        const filtered = row.filter((cell)=>cell !== 0);
        const merged = [];
        let skipNext = false;
        for(let i = 0; i < filtered.length; i++){
            if (skipNext) {
                skipNext = false;
                continue;
            }
            if (filtered[i] === filtered[i + 1]) {
                merged.push(filtered[i] * 2);
                this.score += filtered[i] * 2;
                skipNext = true;
            } else merged.push(filtered[i]);
        }
        while(merged.length < 4)merged.push(0);
        return merged;
    }
    _transposeGrid() {
        this.grid = this.grid[0].map((_, colIndex)=>this.grid.map((row)=>row[colIndex]));
    }
    _addRandomCell() {
        const emptyCells = [];
        for(let row = 0; row < this.grid.length; row++){
            for(let col = 0; col < this.grid[row].length; col++)if (this.grid[row][col] === 0) emptyCells.push({
                row: row,
                col: col
            });
        }
        if (emptyCells.length > 0) {
            const randomIndex = Math.floor(Math.random() * emptyCells.length);
            const { row: row, col: col } = emptyCells[randomIndex];
            this.grid[row][col] = Math.random() < 0.9 ? 2 : 4;
        }
    }
    _postMoveHandler(prevState) {
        if (JSON.stringify(this.grid) !== prevState) {
            this._addRandomCell();
            if (this._checkWin()) this.status = "win";
            else if (!this._hasAvailableMoves()) this.status = "lose";
        }
    }
    _checkWin() {
        return this.grid.some((row)=>row.some((cell)=>cell === 2048));
    }
    _hasAvailableMoves() {
        for(let r = 0; r < 4; r++)for(let c = 0; c < 4; c++){
            if (this.grid[r][c] === 0) return true;
            if (c < 3 && this.grid[r][c] === this.grid[r][c + 1]) return true;
            if (r < 3 && this.grid[r][c] === this.grid[r + 1][c]) return true;
        }
        return false;
    }
}
$a5fd07fa01589658$exports = $a5fd07fa01589658$var$Game;


const $09e991522ca7e64e$var$game = new $a5fd07fa01589658$exports();
const $09e991522ca7e64e$var$startButton = document.querySelector(".button");
const $09e991522ca7e64e$var$scoreElement = document.querySelector(".game-score");
const $09e991522ca7e64e$var$messageStart = document.querySelector(".message-start");
const $09e991522ca7e64e$var$messageWin = document.querySelector(".message-win");
const $09e991522ca7e64e$var$messageLose = document.querySelector(".message-lose");
const $09e991522ca7e64e$var$fieldCells = document.querySelectorAll(".field-cell");
const $09e991522ca7e64e$var$KEY_LEFT = "ArrowLeft";
const $09e991522ca7e64e$var$KEY_RIGHT = "ArrowRight";
const $09e991522ca7e64e$var$KEY_UP = "ArrowUp";
const $09e991522ca7e64e$var$KEY_DOWN = "ArrowDown";
function $09e991522ca7e64e$var$renderGrid() {
    const grid = $09e991522ca7e64e$var$game.getState();
    $09e991522ca7e64e$var$fieldCells.forEach((cell, index)=>{
        const row = Math.floor(index / 4);
        const col = index % 4;
        const value = grid[row][col];
        cell.textContent = value === 0 ? "" : value;
        cell.className = `field-cell ${value ? `field-cell--${value}` : ""}`;
    });
    $09e991522ca7e64e$var$scoreElement.textContent = $09e991522ca7e64e$var$game.getScore();
}
// eslint-disable-next-line no-shadow
function $09e991522ca7e64e$var$handleKeyPress(event) {
    if ($09e991522ca7e64e$var$game.getStatus() !== "playing") return;
    switch(event.key){
        case $09e991522ca7e64e$var$KEY_LEFT:
            $09e991522ca7e64e$var$game.moveLeft();
            break;
        case $09e991522ca7e64e$var$KEY_RIGHT:
            $09e991522ca7e64e$var$game.moveRight();
            break;
        case $09e991522ca7e64e$var$KEY_UP:
            $09e991522ca7e64e$var$game.moveUp();
            break;
        case $09e991522ca7e64e$var$KEY_DOWN:
            $09e991522ca7e64e$var$game.moveDown();
            break;
        default:
            return;
    }
    $09e991522ca7e64e$var$renderGrid();
    $09e991522ca7e64e$var$checkGameStatus();
}
function $09e991522ca7e64e$var$checkGameStatus() {
    if ($09e991522ca7e64e$var$game.getStatus() === "win") $09e991522ca7e64e$var$messageWin.classList.remove("hidden");
    else if ($09e991522ca7e64e$var$game.getStatus() === "lose") $09e991522ca7e64e$var$messageLose.classList.remove("hidden");
}
$09e991522ca7e64e$var$startButton.addEventListener("click", ()=>{
    if ($09e991522ca7e64e$var$startButton.classList.contains("start")) {
        $09e991522ca7e64e$var$game.start();
        $09e991522ca7e64e$var$startButton.classList.remove("start");
        $09e991522ca7e64e$var$startButton.classList.add("restart");
        $09e991522ca7e64e$var$startButton.textContent = "Restart";
        $09e991522ca7e64e$var$messageStart.classList.add("hidden");
    } else {
        $09e991522ca7e64e$var$game.restart();
        $09e991522ca7e64e$var$startButton.classList.remove("restart");
        $09e991522ca7e64e$var$startButton.classList.add("start");
        $09e991522ca7e64e$var$startButton.textContent = "Start";
        $09e991522ca7e64e$var$messageWin.classList.add("hidden");
        $09e991522ca7e64e$var$messageLose.classList.add("hidden");
        $09e991522ca7e64e$var$messageStart.classList.remove("hidden");
    }
    $09e991522ca7e64e$var$renderGrid();
});
document.addEventListener("keydown", $09e991522ca7e64e$var$handleKeyPress);


//# sourceMappingURL=index.cf4f6e48.js.map
